import PaginaAceitacoes from "../../../components/pagina-aceitacoes/PaginaAceitacoes";

export default function () {
  return <PaginaAceitacoes />;
}
